export const convertRegexFromString = (stringPattern: string): RegExp => {
  const pattern = stringPattern.match(/\/(.+)\/.*/)[1];
  const flags = stringPattern.match(/\/.+\/(.*)/)[1];

  return new RegExp(pattern, flags);
};
